<template>
    <div id="winning">
        <van-cell-group>
          <!-- <van-cell is-link :value="redbaoList" to='cash/0'>
            <template slot="title"><img class="user_image_type_img" :src="imgPath+'redbao.png'"/>
              <span class="van-cell-text">红包雨</span>
            </template>
          </van-cell> -->
          <van-cell is-link :value="shakeList" to='cash/1'>
            <template slot="title"><img class="user_image_type_img" :src="imgPath+'shake.png'"/>
              <span class="van-cell-text">摇一摇</span>
            </template>
          </van-cell>
      </van-cell-group>
      <p class="box-center"><span class="red">说明：</span>红包中奖记录在个人中心——收入栏显示明细</p>
    </div>
</template>

<script>
import Vue from 'vue';
import tool from '../../kits/Tools.js';
import vxxData from '../../kits/data.js';
import { Cell, CellGroup } from 'vant';
Vue.use(Cell).use(CellGroup);
    //保存数据

    export default {
        data() {
            return {
              fans_id:"",
              shakeList:0,
              redbaoList:0,
              imgPath:''
            }
        },
        mounted() {
          var current_app_Id = window.localStorage.getItem("current_app_Id");
          var fans = JSON.parse(window.localStorage.getItem(current_app_Id));
          this.fans_id = fans.fans_id;
          this.imgPath = tool.imgPath();
          this.getData();
        },
        methods: {
            getData(){
              var that = this;
              var option = 'fans_id='+this.fans_id;
              this.axios.post(tool.baseUrl()+'/activity/shake/lists',option).then(function(data){
                if(data.data.code == "200") {
                  that.shakeList = data.data.data.count || '0';
                }else{
                  console.log(data.data.message);
                }
              }).catch(function(){
                console.log('错误')
              })
            }
        }
    }
</script>

<style scoped>
img{
  height: 24px;
  line-height: 24px;
  vertical-align:middle;
}
span{
  line-height: 24px;
}
</style>


// WEBPACK FOOTER //
// winning.vue?b5148856